// CookieBanner — the cookie consent bar along the bottom of every keeptabs.app
// page, the same one mytabs.app shows (mytabs-customer-website
// src/views/Corporate/CookieBanner.jsx). Shown until the visitor answers.
// "Accept all" lets the site remember preferences such as light or dark mode;
// "Necessary only" keeps just the cookies the site needs to work.

import React from "react";

import { useCookieConsent } from "./cookies";
import useTheme from "./useTheme";
import "./cookie-banner.css";

const COOKIE_POLICY_URL = "https://mytabs.app/cookies";

export default function CookieBanner() {
  const { open, choose } = useCookieConsent();
  const { theme } = useTheme();

  if (!open) return null;

  return (
    <div className="cookie-banner" data-theme={theme} role="region" aria-label="Cookie consent">
      <div className="cookie-banner__inner">
        <p className="cookie-banner__text">
          <strong>We use cookies.</strong> Some keep the site working. With your OK, we also remember preferences like
          light or dark mode.{" "}
          <a href={COOKIE_POLICY_URL} target="_blank" rel="noopener noreferrer">
            Cookie Policy
          </a>
        </p>
        <div className="cookie-banner__actions">
          <button type="button" className="cookie-banner__btn cookie-banner__btn--ghost" onClick={() => choose("necessary")}>
            Necessary only
          </button>
          <button type="button" className="cookie-banner__btn cookie-banner__btn--primary" onClick={() => choose("all")}>
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
